<template>
  <div class="mt-2 mb-1 text-left crt-deal-create">
    <b-row>
      <b-col>
        <h3>{{ routerParams.dealId != null ? 'Edit' : 'Create' }} {{ routerParams.dealType }}</h3>
      </b-col>
    </b-row>
    <CirtDealEditor
      v-if="routerParams.dealType === 'CIRT'"
      :dealId="routerParams.dealId"
      @backgroundActivity="onBackgroundActivity"
      @userNotification="onUserNotification"></CirtDealEditor>
    <StacrAcisDealEditor
      v-if="routerParams.dealType === 'STACR_ACIS'"
      :dealId="routerParams.dealId"
      @backgroundActivity="onBackgroundActivity"
      @userNotification="onUserNotification"></StacrAcisDealEditor>
  </div>
</template>

<script>
import CirtDealEditor      from '@/components/dealCreate/CirtDealEditor';
import StacrAcisDealEditor from '@/components/dealCreate/StacrAcisDealEditor';
import spinnerState        from '@/components/common/spinner/ObjSpinnerState';
import alertState          from '@/components/common/alert/ObjAlertState';

export default {
  name: 'dealCreate',
  data() {
    return {
      spinnerState,
      alertState
    }
  },
  created() {

  },
  methods:    {
    onBackgroundActivity({value: inProgress = false}) {
      this.spinnerState.isOn = inProgress;
    },
    onUserNotification(notification) {
      const {message, payload: {subType}} = notification;
      if (message && subType) {
        const alertType = (subType === 'success')
          ? 'success'
          : (subType === 'error')
            ? 'danger'
            : 'danger';
        this.alertState.set(message, alertType);
      }
    }
  },
  computed:   {
    routerParams() {
      return {
        dealType: this.$route?.query?.dealType ?? 'CIRT',
        dealId:   this.$route?.query?.dealId,
      }
    },
    /*
        txtDealType() {
          const voc      = {
            cirt:  "CIRT",
            stacr: "STACR",
            acis:  "ACIS",
            bond:  "Bond",
            deal:  "Deal",
          };
          const dealType = this.dealType;
          return voc?.[dealType] || 'Entity';
        }
    */
  },
  components: {
    CirtDealEditor,
    StacrAcisDealEditor,
  }
}
</script>

<style scoped>

</style>
